(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();

  ready(() => {
    const header = document.querySelector('[data-lxi-header]');
    if (!header) return;

    const desktopItems = [...header.querySelectorAll('[data-lxi-desktop-menu]')];

    function activateDesktopPanel(menuItem, url) {
      const selectors = [...menuItem.querySelectorAll('[data-lxi-panel-selector]')];
      const panels = [...menuItem.querySelectorAll('[data-lxi-panel]')];
      const requested = url || selectors[0]?.dataset.lxiPanelSelector;
      selectors.forEach((el) => el.classList.toggle('is-active', el.dataset.lxiPanelSelector === requested));
      let activated = false;
      panels.forEach((panel) => {
        const on = panel.dataset.lxiPanel === requested;
        panel.classList.toggle('is-active', on);
        activated ||= on;
      });
      if (!activated && panels[0]) {
        panels[0].classList.add('is-active');
        selectors[0]?.classList.add('is-active');
      }
    }

    const desktopCloseTimers = new WeakMap();

    function cancelDesktopClose(item) {
      const timer = desktopCloseTimers.get(item);
      if (timer) {
        window.clearTimeout(timer);
        desktopCloseTimers.delete(item);
      }
    }

    function scheduleDesktopClose(item) {
      cancelDesktopClose(item);
      const timer = window.setTimeout(() => {
        item.classList.remove('is-open');
        desktopCloseTimers.delete(item);
      }, 300);
      desktopCloseTimers.set(item, timer);
    }

    desktopItems.forEach((item) => {
      const topLink = item.querySelector('[data-lxi-top-link]');
      const selectors = [...item.querySelectorAll('[data-lxi-panel-selector]')];
      const open = () => {
        cancelDesktopClose(item);
        desktopItems.forEach((other) => {
          if (other !== item) {
            cancelDesktopClose(other);
            other.classList.remove('is-open');
          } else {
            other.classList.add('is-open');
          }
        });
        activateDesktopPanel(item);
      };
      topLink?.addEventListener('mouseenter', open);
      topLink?.addEventListener('focus', open);
      item.addEventListener('mouseenter', () => {
        cancelDesktopClose(item);
        item.classList.add('is-open');
      });
      item.addEventListener('mouseleave', () => scheduleDesktopClose(item));
      selectors.forEach((selector) => {
        const switchPanel = () => activateDesktopPanel(item, selector.dataset.lxiPanelSelector);
        selector.addEventListener('mouseenter', switchPanel);
        selector.addEventListener('focus', switchPanel);
        selector.addEventListener('click', (event) => {
          if (window.matchMedia('(pointer: coarse)').matches) {
            const isActive = selector.classList.contains('is-active');
            if (!isActive) {
              event.preventDefault();
              switchPanel();
            }
          }
        });
      });
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) desktopItems.forEach((item) => item.classList.remove('is-open'));
    });

    const drawer = document.querySelector('[data-lxi-mobile-drawer]');
    const overlay = document.querySelector('[data-lxi-mobile-overlay]');
    const toggle = header.querySelector('[data-lxi-mobile-toggle]');
    const close = drawer?.querySelector('[data-lxi-mobile-close]');
    if (!drawer || !toggle || !overlay) return;

    const rootWrap = drawer.querySelector('[data-lxi-mobile-roots]');
    const viewsWrap = drawer.querySelector('[data-lxi-mobile-views]');
    const tabs = [...drawer.querySelectorAll('[data-lxi-mobile-tab]')];
    const roots = [...drawer.querySelectorAll('[data-lxi-mobile-root]')];
    const views = [...drawer.querySelectorAll('[data-lxi-mobile-view]')];

    let currentGroup = 'personalized';

    function showRoot(group) {
      currentGroup = group || currentGroup;
      viewsWrap.hidden = true;
      rootWrap.hidden = false;
      roots.forEach((root) => root.classList.toggle('is-active', root.dataset.lxiMobileRoot === group));
      tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.lxiMobileTab === group));
    }

    function showView(url) {
      rootWrap.hidden = true;
      viewsWrap.hidden = false;
      views.forEach((view) => view.classList.toggle('is-active', view.dataset.lxiMobileView === url));
      viewsWrap.scrollTop = 0;
      drawer.querySelector('.lxi-mobile-drawer__inner')?.scrollTo(0, 0);
    }

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
      showRoot(tabs[0]?.dataset.lxiMobileTab || 'personalized');
      close?.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }

    toggle.addEventListener('click', openDrawer);
    close?.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    tabs.forEach((tab) => tab.addEventListener('click', () => showRoot(tab.dataset.lxiMobileTab)));
    drawer.querySelectorAll('[data-lxi-mobile-open]').forEach((button) => button.addEventListener('click', () => showView(button.dataset.lxiMobileOpen)));
    drawer.querySelectorAll('[data-lxi-mobile-back]').forEach((button) => button.addEventListener('click', () => showRoot(button.dataset.lxiMobileBack === 'current' ? currentGroup : button.dataset.lxiMobileBack)));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        desktopItems.forEach((item) => item.classList.remove('is-open'));
        if (drawer.classList.contains('is-open')) closeDrawer();
      }
    });
  });
})();
